<template>
    
    <b-row>
        <b-col cols="4" v-if="file">
            <div class="info-card px-2 py-1 my-1">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                ملف محضر الجلسة الإدارية {{ data.meeting_minute_id ? data.meeting_minute_id.meeting_minutes_label : ''  }} التي تمّ خلالها تحديد موعد اجتماع الهيئة العامة
                </div>
                <div>
                <b-button
                
                    variant="flat-info"
                    v-b-toggle.doc-view
                    class="btn-icon mx-25"
                    v-b-tooltip.hover.v-info.bottom
                    title="عرض المستند المرفوع"
                    :to="{ name: 'file-view', query: { ep:file  } }"
                >
                    <feather-icon icon="EyeIcon"
                /></b-button>
                </div>
            </div>
            <div>
                <hr />
            </div>
            </div>
        </b-col> 
        
        <b-col md="4" cols="12" v-else>
            <info-card
            label="رقم محضر الجلسة الإدارية التي تمّ خلالها تحديد موعد اجتماع الهيئة العامة"
            :value="data.meeting_minute_id ? data.meeting_minute_id.meeting_minutes_label :''"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card
            label="موعد الاجتماع الأول"
            :value="data.first_meeting_date"
            />
        </b-col> 
        <b-col md="4" cols="12">
            <info-card
            label="موعد الاجتماع الثاني"
            :value="data.second_meeting_date"
            />
        </b-col> 
        <b-col md="4" cols="12">
            <info-card
            label="مكان عقد الاجتماع"
            :value="data.meeting_location"
            />
        </b-col>    
        <b-col md="4" cols="12">
            <info-card
            label="عدد أعضاء الهيئة العامة"
            :value="data.general_authority_members_count"
            />
        </b-col>    
        <b-col md="4" cols="12">
            <info-card
            label="عدد أعضاء الهيئة العامة الذين يحق لهم الحضور"
            :value="data.general_authority_members_who_can_attend_count"
            />
        </b-col>    
        <b-col md="4" cols="12">
            <info-card
            label="جدول الاحتماع"
            :value="data.business_schedule"
            />
        </b-col>       
        <b-col md="4" cols="12" v-if="data.does_meeting_include_nomination_of_board_members === 'true'">
            <info-card
            label="أسماء المرشحين لعضوية مجلس الإدارة"
            :value="data.directors_board_candidates_membership_names"
            />
        </b-col>      
    </b-row>
  </template>
  
  <script>
  import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
  import InfoCard from "@/components/InfoCard.vue";
  import axios from "@axios";
  import router from "@/router";

  export default {
    components: {
        BCard, BImg , BCol , InfoCard , BRow , BButton
    },
    data() {
        return {
            file: '',
        }
    },
    props: {
        data :Object ,
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
    watch: {
        data: {
        handler: async function(newVal, oldVal) {
            
            const currentRoute = router.currentRoute.path.includes('ministry')
            if(currentRoute){
                console.log("currentRoute" , currentRoute)
                await axios.get(`v2/ministry/ngo-meeting-minutes/${this.data.meeting_minute_id.id}`).then((res) => this.file=res.data.data.file);
            }
            else{
                this.file=null
            }
        },
        deep: true
        }
    },
  };
  </script>